export default __webpack_public_path__ + "static/media/target-groups.5306039f.png";